/* unplugin-vue-components disabled */import { render } from "./templateUpload.vue?vue&type=template&id=8107ffa2&scoped=true"
import script from "./templateUpload.vue?vue&type=script&lang=js"
export * from "./templateUpload.vue?vue&type=script&lang=js"

import "./templateUpload.vue?vue&type=style&index=0&id=8107ffa2&scoped=true&lang=css"
import "./templateUpload.vue?vue&type=style&index=1&id=8107ffa2&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8107ffa2"]])

export default __exports__